import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Thin top progress bar shown briefly on route changes.
 * Used as a lightweight replacement for a full-screen Suspense spinner
 * so the previous page stays visible while the next lazy chunk loads.
 */
export function RouteProgress({ active }: { active?: boolean }) {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setVisible(true);
    setProgress(15);
    const t1 = setTimeout(() => setProgress(55), 80);
    const t2 = setTimeout(() => setProgress(85), 250);
    const t3 = setTimeout(() => {
      setProgress(100);
      setTimeout(() => setVisible(false), 200);
    }, 500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [location.pathname]);

  const show = visible || active;
  if (!show) return null;

  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 right-0 z-[9999] h-[2px] pointer-events-none"
    >
      <div
        className="h-full bg-primary shadow-[0_0_8px_hsl(var(--primary))] transition-all duration-200 ease-out"
        style={{ width: `${active ? Math.max(progress, 90) : progress}%`, opacity: show ? 1 : 0 }}
      />
    </div>
  );
}
